module.exports = __webpack_public_path__ + "static/media/high_scalability.33e73f5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/high_scalability.svg
// module id = 388
// module chunks = 0